<template>
  <div id="app">
    <!-- Header (顶部导航) -->
    <header>
      <div class="wrap">
        <div class="header-box">
          <div class="logo">
            <router-link to="/" >
              <img src="@/assets/images/logo.png">
            </router-link>
            <p>全网价值营销服务商</p>
          </div>
          <ul class="menulist">
            <li v-for="item in menuList" :key="item.path">
              <router-link 
                :to="item.path" 
                :class="{ active: $route.path === item.path }"
              >{{ item.name }}</router-link>
            </li>
          </ul>
        </div>
      </div>
    </header>

    <!-- Content Area (内容区域) -->
    <div class="content">
      <router-view></router-view>  <!-- 动态内容区，根据路由切换 -->
      <!-- Footer (底部) -->
      <footer>
        <FooterModule/>
      </footer>
    </div>
  </div>
</template>

<script>
import FooterModule from '@/components/FooterModule.vue';
export default {
  components: { FooterModule },
  name: 'App',
  data() {
    return {
      menuList: [
        { path: '/', name: '首页' },
        { path: '/Solution', name: '解决方案' },
        { path: '/Case', name: '客户案例' },
        { path: '/AboutUs', name: '关于我们' },
        { path: '/ContactUs', name: '联系我们' },
      ]
    }
  },
};
</script>


<style scoped>
/* 通用布局样式 */
#app {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

header {
  padding: 20px 0;
  box-shadow: 0 5px 10px -5px rgba(0, 0, 0, 0.3);
}
.header-box{
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 50px;
}
.header-box .logo{
  display: flex;
  gap: 15px;
  align-items: center;
  justify-content: flex-start; /* 让内容靠左排列，避免挤压文字 */
  /* width: 465px;
  height: 80px; */
}
.header-box .logo p{
  font-size: 14px;
  color: #888888;
  white-space: nowrap; 
  /* 不被flex布局压缩 */
  flex-shrink: 0; 
  /* 也可以给容器设置足够宽度 */
  width: auto;
}
.header-box .logo img{
  display: block;
  width: 160px;
}
.header-box .menulist{
  /* flex: 1; */
  display: flex;
  justify-content: right;
  gap: 80px;
}
.header-box .menulist li a{
  font-size: 16px;
  color: #111111;
}
.header-box .menulist li a:hover{
  color: #1639a2;
}

.content {
  flex: 1;
  overflow-y: auto;
}

footer {
  background-color: #222222;
  color: #888888;
}
/* 高亮样式（可根据需求自定义） */
.header-box .menulist li a.active {
  color: #1639a2; /* 高亮文字颜色 */
}

</style>
